import React, { Fragment, useMemo } from 'react';

import { translate } from '@vestahealthcare/common/i18n';
import { MemberPhone } from '@vestahealthcare/common/models';

import { PhoneLink } from 'styleguide-v2';

import { DetailItem } from '../utils';

type Props = {
  phones?: MemberPhone[];
};

const getPhoneLabel = (phone: MemberPhone) => {
  let ending = '';
  if (phone.preferred) ending = ` (${translate('global.preferred')})`;
  else if (phone.primary) ending = ` (${translate('global.primary')})`;

  return `${phone?.phone?.type?.toString() || ''}${ending}`;
};

export const MemberPhonesDetail = ({ phones }: Props) => {
  const sortedPhones = useMemo(
    () =>
      phones?.filter(MemberPhone.filterActive)?.sort(MemberPhone.sortByType),
    [phones],
  );
  return (
    <>
      {sortedPhones?.length ? (
        sortedPhones.map((userPhone, idx) => (
          <DetailItem
            avoidTranslation
            key={`member-phone-${userPhone.id}`}
            label={getPhoneLabel(userPhone)}
            noMarginBottom={idx !== sortedPhones.length - 1}
          >
            <PhoneLink
              compact
              hidePrimary
              phone={userPhone.phone.number}
              type={userPhone.phone.type?.toString()}
            />
          </DetailItem>
        ))
      ) : (
        <DetailItem label="phoneNumber" />
      )}
    </>
  );
};
